import { Col, Form, Input, Row, theme, Select, Divider, Typography, message, notification } from "antd";
import EditQty from "./EditQty";
import { useEffect, useState, useMemo } from "react";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router";
import ManageGarmentService from "../../../../../services/ManageGarmentService";
import LoadingSpin from "../../../../loadingSpin/LoadingSpin";
import ResponseMessage from "../../../../Comman/Notification/ResponseMessge";

const EditViewGarments = ({
    userData,
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const { Title, Text } = Typography;
    const [kbNumber, setKbNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [getKanbanData, setKanbanData] = useState();
    const [api, contextHolder] = notification.useNotification();

    useEffect(() => {
        const fetchKanbanData = async () => {
            const queryParams = new URLSearchParams(location.search);
            const kbNumValue = queryParams.get('kb_num');
            const bin_id = queryParams.get('bin_id');

            setKbNumber(kbNumValue);

            if (!kbNumValue) {
                ResponseMessage.error({ message : "No Kanban number provided."});
                return;
            }

            setIsLoading(true);
            try {
                const response = await ManageGarmentService.add_garment(kbNumValue);

                if (Array.isArray(response.data) && response.data.length > 0) {
                    setKanbanData(response.data);
                } else {
                    openNotificationWithIcon('warning', 'No Data Found', response.message || 'No Kanban data available.');
                    navigate(-1);
                }
            } catch (error) {
                console.error("Error fetching Kanban data:", error);
                openNotificationWithIcon('error', 'Error', 'An error occurred while fetching data.');
                navigate(-1);
            } finally {
                setIsLoading(false);
            }
        };

        fetchKanbanData();
    }, [location]);

    console.log("getKanbanData", getKanbanData);
    const openNotificationWithIcon = (type, title, description) => {
        api[type]({
            message: title,
            description,
        });
    };

    const kanbanData1 = useMemo(() => {
        return Array.isArray(getKanbanData) && getKanbanData.length > 0
            ? getKanbanData.map(item => ({
                kanbanNo: item.kb_number,
                poNo: item.po_no,
                quantity: item.quantity,
                color: item.color,
                itemNo: item.item_no,
                country: item.country,
                totalQty: item.tot_qty,
                db_id: item.dbd_id,
            }))
            : [];
    }, [getKanbanData]);

    const handleArrowClick = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (kanbanData1.length > 0) {
            form.setFieldsValue(kanbanData1[0]);
        }
    }, [kanbanData1, form]);

    const sizeCollection = useMemo(() => {
        return Array.isArray(getKanbanData)
            ? getKanbanData.map(item => {
                const sizes = JSON.parse(item.size_name || '{}');
                return Object.entries(sizes).map(([size, quantity], idx) => ({
                    key: `${idx + 1}`,
                    kanban_no: item.kb_number,
                    size,
                    avilableQty: quantity || "0",
                    totalQty: item.tot_qty,
                    db_id: item.dbd_id,
                })).filter(entry => entry.avilableQty !== "0");
            }).flat()
            : [];
    }, [getKanbanData]);
    console.log(sizeCollection);


    const formStyle = {
        marginTop: '-15px',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
    };

    const onFinish = (values) => {
        console.log("Form Submitted:", values);
    };


    return (
        <div>
            <Title level={5} style={{ marginTop: -15, margin: 0 }}>
                <div>
                    <>
                        <ArrowLeftOutlined onClick={handleArrowClick} style={{ paddingRight: '10px' }} />
                        Edit Garment
                    </>
                </div>
            </Title>

            <Divider style={{ marginTop: 8 }} />
            {contextHolder}
            {isLoading && <LoadingSpin />}
            {!isLoading && (

                <Form
                    form={form}
                    name="simple_search"
                    style={formStyle}
                    onFinish={onFinish}
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 18,
                    }}
                >
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item name="kanbanNo" label="Kanban NO">
                                <Input
                                    style={{
                                        backgroundColor: '#9F5375',
                                        color: 'white',
                                        borderRadius: '0px',
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="itemNo" label="Item No">
                                <Input
                                    style={{
                                        backgroundColor: '#9F5375',
                                        color: 'white',
                                        borderRadius: '0px',
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item name="poNo" label="PO NO">
                                <Input
                                    style={{
                                        backgroundColor: '#9F5375',
                                        color: 'white',
                                        borderRadius: '0px',
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="color" label="Color">
                                <Input
                                    style={{
                                        backgroundColor: '#9F5375',
                                        color: 'white',
                                        borderRadius: '0px',
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item name="country" label="Country">
                                <Input
                                    style={{
                                        backgroundColor: '#9F5375',
                                        color: 'white',
                                        borderRadius: '0px',
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="totalQty" label="Total QTY">
                                <Input
                                    style={{
                                        backgroundColor: '#9F5375',
                                        color: 'white',
                                        borderRadius: '0px',
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <div
                        style={{
                            marginTop: '20px',
                            marginLeft: '10%',
                        }}
                    >
                        <EditQty userData={userData} handleArrowClick={handleArrowClick} editValue={sizeCollection} />
                    </div>
                </Form>
            )};
        </div>
    );
};

export default EditViewGarments;